
<template>
  <!--访客记录-->
  <div>
    <x-tabula
      :apiOrigin="apiOrigin"
      ref="table"
      :dataSource="dataSource"
      rowKey="visitor_recode_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :deleteParam="deleteParam"
      :rowSelection="false"
      @resetSearch = "resetSearch"
    >
      <template slot="opt_t" slot-scope="{row}">
        <a-tooltip>
          <p slot="title">{{row.room_desc}}</p>
          <template>
            <span v-if="row.room_desc.length > 14">{{row.room_desc.substr(0,14) + '...'}}</span>
            <span v-else>{{row.room_desc}}</span>
          </template>
        </a-tooltip>
      </template>
    </x-tabula>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  mixins: [fetchSelect],
  name: 'visitorRecord',
  data () {
    return {
      apiOrigin: 'PHP',
      listInterval: '',
      searchList: [
        { props: ['community_id'], placeholder: '选择小区', options: [], inputType: 'select', fetchOptions: this.getOptions},
        { props: ['household_phone'], placeholder: '被访人手机', options: [], inputType: 'input' },
        { props: ['visitor_phone'], placeholder: '访客手机', options: [], inputType: 'input' },
        { props: ['create_date'], placeholder: ['开始时间', '结束时间'], options: [], inputType: 'dateTimePick' },
        { props: ['type'], placeholder: '类型', options: [], inputType: 'select' },
        { props: ['status'], placeholder: '状态', options: [], inputType: 'select' }
      ],
      tableOptList: [],
      rowOptList: [
        { text: '查看', handle: (row) => this.toDetail(row.visitor_apply_id), permi: ['device:visitor:detail'] }
      ],
      columns: [
        { title: '被访人', dataIndex: 'household_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'household_phone', align: 'left', width: '' },
        { title: '被访人房间', dataIndex: 'room_desc', align: 'left', width: '', scopedSlots: {customRender: 't'} },
        { title: '类型', dataIndex: 'type_desc', align: 'left', width: '' },
        { title: '访客', dataIndex: 'visitor_name', align: 'left', width: '' },
        { title: '手机号', dataIndex: 'visitor_phone', align: 'left', width: '' },
        { title: '来访事由', dataIndex: 'visit_reason', align: 'left', width: '' },
        { title: '来访时间', dataIndex: 'visitor_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '申请时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        community_id: undefined,
        household_phone: undefined,
        visitor_phone: undefined,
        create_date: undefined,
        type: undefined,
        status: undefined
      },
      listApi: {
        url: '/visitor_record',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {}
    };
  },
  created () {
    this.getSelect();
  },
  beforeDestroy () {
    clearInterval(this.listInterval);
  },
  methods: {
    resetSearch () {
      this.communitySelectByStep(undefined, undefined, 'searchList', '0');
      this.searchList[0].searchValue = undefined;
    },
    getOptions (pageNum, search) {
      return this.communitySelectByStep(pageNum, search, 'searchList', '0');
    },
    /* 进入详情页面 */
    toDetail (id) {
      this.$router.push({
        name: 'recordDetail',
        query: { id, title: '访客记录详情', ...this.breadParam(this) }
      });
    },
    getSelect () {
      this._get({
        url: '/select_list/visitor_record_list'
      }).then(({data}) => {
        this.searchList[5].options = data.visitor_status;
      });
      // this.communitySelect(0, 'searchList', 1);
      this.communitySelectByStep(1, undefined, 'searchList', '0');
      this.searchList[4].options = [
        { value: 1, label: '访客登记' },
        { value: 2, label: '访客邀请' }
      ];
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      return selectData;
    }
  }
};
</script>
